<template>
<div id="Vue" style="background:#eceaea;">
 
<el-row style="background: #fff;width:100%; height:80px" justify="space-between"> 
  <el-col :span="2"><div  ><a href="/" title="智造云"  >
                 <img  src="/static/picture/logo.png" style="height:60px;width:60px; margin-top:5px;margin-left:10px" >
                </a> </div>
  </el-col>
  <el-col :span="8">
  <el-breadcrumb separator-class="el-icon-arrow-right" style="  margin-top:36px;margin-left:10px">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ path: '/customs/index' }">海关数据</el-breadcrumb-item>
  <el-breadcrumb-item>账户设置</el-breadcrumb-item> 
</el-breadcrumb>
  </el-col>
 </el-row>
   
 
<el-container style="height: 800px; border: 1px solid #eee">
 
  <el-container> 
  <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
    <el-menu  @select="handleSelect" :default-openeds="['1','2','3']" >
      <el-submenu index="1">
        <template slot="title"><i class="el-icon-message"></i>账户设置</template>
        
          <el-menu-item index="1-1">账户信息</el-menu-item>
          <el-menu-item index="1-2">修改密码</el-menu-item>
        
 
      </el-submenu>
      <el-submenu index="2">
        <template slot="title"><i class="el-icon-menu"></i>订单管理</template>
       
          <el-menu-item index="2-1">我的订单</el-menu-item>
          <el-menu-item index="2-2">我的发票</el-menu-item>
     
 
      </el-submenu>
      <el-submenu index="3">
        <template slot="title"><i class="el-icon-setting"></i>浏览记录</template> 
          <el-menu-item index="3-2">领英数据记录</el-menu-item>
          <el-menu-item index="3-1">查询记录</el-menu-item>
       
      </el-submenu>
    </el-menu>
  </el-aside>
  <el-main style="align-items: center;">  
   <router-view> 
    
  </router-view>
  </el-main>
 

  
</el-container>

</el-container>

<bottom> </bottom>	
</div>
</template>


<script>
import bottom from '@/components/appFooter'
  export default {
        name: "header",
        data () {
		  return{
	    	componentName: 'info',
		    userInfo: {},
			login_state : 0,
            text: "hallo,word",
            img: "",
            arr: [],
			
			}
			  
        },
		components:{bottom },
        methods: { 
          handleTop(key, keyPath) { 
		    if (key == '1'){
 
				  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });
				}
		    if (key == '2'){
                  localStorage.setItem('userInfo',  '');
				  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });
				}				
				
				
		  },
		  handleSelect(key, keyPath) { 
		    let that = this; 
			console.log(key);
		    if (key == '1-1'){
 
				  this.$router.push({
					name: 'myInfo',
					params: {
					  sometext: ''
					}
				  });
				}
		    if (key == '1-2'){ 
				  this.$router.push({
					name: 'changePwd',
					params: {
					  sometext: ''
					}
				  }); 
		        } 
		    if (key == '2-1'){ 
				  this.$router.push({
					name: 'order',
					params: {
					  sometext: ''
					}
				  }); 
		        } 
		    if (key == '2-2'){ 
				  this.$router.push({
					name: 'invoice',
					params: {
					  sometext: ''
					}
				  }); 
		        } 
		    if (key == '3-1'){ 
				  this.$router.push({
					name: 'queryLog',
					params: {
					  sometext: ''
					}
				  }); 
		        } 				
		    if (key == '3-2'){ 
				  this.$router.push({
					name: 'linkedInDetail',
					params: {
					  sometext: ''
					}
				  }); 
		        } 				
        },
		logout()
		{
		  console.log('out');
		  localStorage.setItem('userInfo',  '');
		  window.location.href= '/out';  
		},
        created() {
		
		},
		  	
        mounted() {
		  	 
			console.log('hi');
            let that = this;
		    var info1 = localStorage.getItem("userInfo"); 
            var userName = '';
            var userId = 0;
            var userPhone = '';
            var userEmail = '';
            if (info1 != undefined && info1 != '' && info1 != "undefined"){
              var info = JSON.parse(info1);
              that.userInfo = info ;   
			  console.log(that.userInfo);
			  }else
			  {
			  console.log(info1);
			  }
		
           }
         
		}
    } ;


	 
</script>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

 
 


// WEBPACK FOOTER //
// src/components/setting/setting.vue